import { markRaw } from 'vue'

let pdfjsLib: any = null

export async function usePdfJs() {
  if (pdfjsLib) return pdfjsLib

  const lib: any = await import('pdfjs-dist/build/pdf')
  const workerUrlMod: any = await import('pdfjs-dist/build/pdf.worker.min.mjs?url')
  lib.GlobalWorkerOptions.workerSrc = workerUrlMod.default

  pdfjsLib = markRaw(lib)
  return pdfjsLib
}
